import React, { createContext, useState } from "react";
import { BilletTypes } from "../children/BilletTypes";

const BoletoContext = createContext();
//TODO
//Limpar o context

const BoletoContextProvider = ({ children }) => {
  //Principal
  const [contracts, setContracts] = useState([]);
  const [contractData, setContractData] = useState(null);
  const [billetData, setBilletData] = useState([]);
  const [token, setToken] = useState("");
  const [email, setEmail] = useState("");
  const [empresaCnpj, setEmpresaCnpj] = useState("");
  const [password, setPassword] = useState("");
  const [companyName, setCompanyName] = useState("");
  const [companyLogoUrl, setCompanyLogoUrl] = useState("");
  const [billetType, setBilletType] = useState(BilletTypes.accountsReceivable);
  const [isPageLoading, setPageLoading] = useState(true);
  const [isButtonLoading, setButtonLoading] = useState(false);
  const [hasError, setError] = useState(false);

  return (
    <BoletoContext.Provider
      value={{
        contractData,
        setContractData,
        billetData,
        setBilletData,
        token,
        setToken,
        email,
        setEmail,
        empresaCnpj,
        setEmpresaCnpj,
        password,
        setPassword,
        companyName,
        setCompanyName,
        companyLogoUrl,
        setCompanyLogoUrl,
        isPageLoading,
        setPageLoading,
        isButtonLoading,
        setButtonLoading,
        hasError,
        setError,
        contracts,
        setContracts,
        billetType,
        setBilletType,
      }}
    >
      {children}
    </BoletoContext.Provider>
  );
};

export { BoletoContextProvider, BoletoContext };
